module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    staticClass: "view"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0246d176!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 229
// module chunks = 2